import { Controller } from "@hotwired/stimulus"
import { FetchRequest, get } from '@rails/request.js'

export default class extends Controller {
  static values = {
    searchUrl: String,
    selectUrl: String,
    formElement: String,
    formId: String,
  }
  static targets = ["searchField", "clearButton"]
  static timeoutId = null

  connect() {
    this.syncClearButton()
  }

  searchFieldValue() {
    if (this.hasSearchFieldTarget) return this.searchFieldTarget.value
    const el = document.getElementById("searchfield")
    return el ? el.value : ""
  }

  syncClearButton() {
    if (!this.hasClearButtonTarget) return
    this.clearButtonTarget.classList.toggle("d-none", !this.searchFieldValue())
  }

  clearSearch(event) {
    event?.preventDefault()
    clearTimeout(this.timeoutId)
    if (this.hasSearchFieldTarget) {
      this.searchFieldTarget.value = ""
      this.searchFieldTarget.focus()
    } else {
      const el = document.getElementById("searchfield")
      if (el) el.value = ""
    }
    this.syncClearButton()
    this.request(this.searchUrlValue)
  }

  async link(event) {
    // Get URL from data-table-select-url-param attribute
    const url = event.params.selectUrl
    const type = event.params.type || "html"

    if (url) {
      if (type == "html") {
        Turbo.visit(url)
        return;
      } else {
        const request = fetch(
          url,
          {
            headers: {
              Accept: "text/vnd.turbo-stream.html",
            }
          }
        )
        .then(r => r.text())
        .then(html => Turbo.renderStreamMessage(html))
      }
    }
  }

  // async select(event) {
  //   // document.getElementById(this.formElementValue).value = event.params.objectid
  //   // document.getElementById(this.formIdValue).requestSubmit()
  //   console.log(event)
  //   const request = new FetchRequest(
  //     "post",
  //     this.selectUrlValue,
  //     {
  //       body: JSON.stringify({
  //         entity_id: event.params.objectid
  //       }),
  //       responseKind: "turbo-stream"
  //     }
  //   )
  //   const response = await request.perform()
  //   if (response.ok) {
  //     const body = await response.text
  //     Turbo.renderStreamMessage(body)
  //   }
  // }

  async select(event) {
    let json_data = {}
    json_data[`${event.params.model.toLowerCase()}_${event.params.association}`] = {
      resource_id: event.params.objectid,
      resource_type: event.params.objecttype
    }
    const request = new FetchRequest(
      "post",
      this.selectUrlValue,
      {
        body: JSON.stringify(json_data),
        responseKind: "turbo-stream"
      }
    )
    const response = await request.perform()
    if (response.ok) {
      const body = await response.text
      Turbo.renderStreamMessage(body)
    }
  }

  async getDetail(event) {
    const response = await get(event.params.detailUrl, { responseKind: "turbo-stream" })
    if (response.ok) {
      const html = await response.text
      Turbo.renderStreamMessage(html)
    } 
  }

  async sort(event) {
    // Get URL from data-table-sort-url-param attribute
    // Rails converts data: { table_sort_url_param: link } to data-table-sort-url-param HTML attribute
    const url = event.target.dataset.tableSortUrlParam
    if (url) {
      // Show loading indicator
      document.dispatchEvent(new CustomEvent("turbo:submit-start"))
      
      try {
        // Make a POST request for sorting in association modals
        const request = new FetchRequest(
          "post",
          url,
          {
            responseKind: "turbo-stream"
          }
        )
        const response = await request.perform()
        if (response.ok) {
          const body = await response.text
          Turbo.renderStreamMessage(body)
        }
      } finally {
        // Hide loading indicator
        document.dispatchEvent(new CustomEvent("turbo:submit-end"))
      }
    }
  }

  refresh(event) {
    //this.visit(this.urlParameters(event), { frame: "table"} )
    this.request(this.searchUrlValue)
  }

  keyup(event) {
    this.syncClearButton()
    clearTimeout(this.timeoutId)
    const requestParams = event.params.hasOwnProperty("requestparams") ? event.params.requestparams : null
    this.timeoutId = setTimeout(() => {
      this.request(this.searchUrlValue, null, requestParams)
    }, 300)
  }

  // Reads the current value of every filter control (status/building complex/
  // responsible-or-reporter selects) marked with `data-filter-name` inside this
  // controller's element, and re-runs the search with them as extra params —
  // used by the ResidentReport<->Task associate modals' extra filter row.
  // Additive: existing associate modals (Person/BuildingComplex/etc.) have no
  // such elements, so this is a no-op for them.
  filterChange(event) {
    const filters = {}
    this.element.querySelectorAll("[data-filter-name]").forEach((el) => {
      if (el.value) filters[el.dataset.filterName] = el.value
    })
    this.request(this.searchUrlValue, null, filters)
  }

/*   fetch(url) {
    fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'text/vnd.turbo-stream.html'
        }
      }
    ).then (response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  } */

  async request(url, method, params = {}) {
    const request = new FetchRequest(
      "post",
      url,
      {
        body: JSON.stringify(Object.assign(
          {
            search: this.searchFieldValue()
          },
          params || {}
        )),
        responseKind: "turbo-stream"
      }
    )
    const response = await request.perform()
    if (response.ok) {
      const body = await response.text
      Turbo.renderStreamMessage(body)
    }
  }

  visit(url) {
    Turbo.visit(url, { frame: "table"} )
  }

}
